/*
 *
 * PatientDetails constants
 *
 */

export const GET_PATIENT_DETAILS_REQUEST_SENT = 'src/PatientDetails/GET_PATIENT_DETAILS_REQUEST_SENT';
export const GET_PATIENT_DETAILS_REQUEST_SUCCEED = 'src/PatientDetails/GET_PATIENT_DETAILS_REQUEST_SUCCEED';
export const GET_PATIENT_DETAILS_REQUEST_FAILED = 'src/PatientDetails/GET_PATIENT_DETAILS_REQUEST_FAILED';

export const REMOVE_PATIENT_REQUEST_SENT = 'src/PatientDetails/REMOVE_PATIENT_REQUEST_SENT';
export const REMOVE_PATIENT_REQUEST_SUCCEED = 'src/PatientDetails/REMOVE_PATIENT_REQUEST_SUCCEED';
export const REMOVE_PATIENT_REQUEST_FAILED = 'src/PatientDetails/REMOVE_PATIENT_REQUEST_FAILED';

export const UPDATE_NEEDS_ATTENTION_REQUEST_SENT = 'src/PatientDetails/UPDATE_NEEDS_ATTENTION_REQUEST_SENT';
export const UPDATE_NEEDS_ATTENTION_REQUEST_SUCCEED = 'src/PatientDetails/UPDATE_NEEDS_ATTENTION_REQUEST_SUCCEED';
export const UPDATE_NEEDS_ATTENTION_REQUEST_FAILED = 'src/PatientDetails/UPDATE_NEEDS_ATTENTION_REQUEST_FAILED';

export const RESEND_INVITE_REQUEST_SENT = 'src/PatientDetails/RESEND_INVITE_REQUEST_SENT';
export const RESEND_INVITE_REQUEST_SUCCEED = 'src/PatientDetails/RESEND_INVITE_REQUEST_SUCCEED';
export const RESEND_INVITE_REQUEST_FAILED = 'src/PatientDetails/RESEND_INVITE_REQUEST_FAILED';

export const SET_PHASE_ID = 'src/PatientDetails/SET_PHASE_ID';

export const UPDATE_PATIENT_INFO_REQUEST_SENT = 'src/PatientDetails/UPDATE_PATIENT_INFO_REQUEST_SENT';
export const UPDATE_PATIENT_INFO_REQUEST_SUCCEED = 'src/PatientDetails/UPDATE_PATIENT_INFO_REQUEST_SUCCEED';
export const UPDATE_PATIENT_INFO_REQUEST_FAILED = 'src/PatientDetails/UPDATE_PATIENT_INFO_REQUEST_FAILED';
export const RESET_PATIENT_DETAILS = 'src/PatientDetails/RESET_PATIENT_DETAILS';

export const TERMINATE_PROCEDURE_TRIAL_REQUEST_SENT = 'src/PatientDetails/TERMINATE_PROCEDURE_TRIAL_REQUEST_SENT';
export const TERMINATE_PROCEDURE_TRIAL_REQUEST_SUCCEED = 'src/PatientDetails/TERMINATE_PROCEDURE_TRIAL_REQUEST_SUCCEED';
export const TERMINATE_PROCEDURE_TRIAL_REQUEST_FAILED = 'src/PatientDetails/TERMINATE_PROCEDURE_TRIAL_REQUEST_FAILED';

export const DELETE_PATIENT_REQUEST_SENT = 'src/PatientDetails/DELETE_PATIENT_REQUEST_SENT';
export const DELETE_PATIENT_REQUEST_SUCCEED = 'src/PatientDetails/DELETE_PATIENT_REQUEST_SUCCEED';
export const DELETE_PATIENT_REQUEST_FAILED = 'src/PatientDetails/DELETE_PATIENT_REQUEST_FAILED';

export const TRACK_PATIENT_AS_VIEWED_REQUEST_SENT = 'app/PatientDetails/TRACK_PATIENT_AS_VIEWED_REQUEST_SENT';
export const TRACK_PATIENT_AS_VIEWED_REQUEST_SUCCEED = 'app/PatientDetails/TRACK_PATIENT_AS_VIEWED_REQUEST_SUCCEED';
export const TRACK_PATIENT_AS_VIEWED_REQUEST_FAILED = 'app/PatientDetails/TRACK_PATIENT_AS_VIEWED_REQUEST_FAILED';

export const GET_MANIFEST_ORDER_REQUEST_SENT = 'app/PatientDetails/GET_MANIFEST_ORDER_REQUEST_SENT';
export const GET_MANIFEST_ORDER_REQUEST_SUCCEED = 'app/PatientDetails/GET_MANIFEST_ORDER_REQUEST_SUCCEED';
export const GET_MANIFEST_ORDER_REQUEST_FAILED = 'app/PatientDetails/GET_MANIFEST_ORDER_REQUEST_FAILED';
export const RESET_MANIFEST_ORDER_DATA = 'app/PatientDetails/RESET_MANIFEST_ORDER_DATA'